import { Injectable, signal } from '@angular/core';

export interface ToastItem {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  title?: string;
  message: string;
  duration: number;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  public toasts = signal<ToastItem[]>([]);

  show(
    message: string,
    type: 'success' | 'error' | 'warning' | 'info' = 'info',
    title?: string,
    duration: number = 4500
  ): string {
    const id = Math.random().toString(36).substring(2, 9);
    const newToast: ToastItem = {
      id,
      type,
      title,
      message,
      duration,
    };

    this.toasts.update((current) => [...current, newToast]);

    if (duration > 0) {
      setTimeout(() => {
        this.dismiss(id);
      }, duration);
    }

    return id;
  }

  success(message: string, title?: string, duration: number = 4500) {
    return this.show(message, 'success', title, duration);
  }

  error(message: string, title?: string, duration: number = 6500) {
    return this.show(message, 'error', title, duration);
  }

  warning(message: string, title?: string, duration: number = 5000) {
    return this.show(message, 'warning', title, duration);
  }

  info(message: string, title?: string, duration: number = 4500) {
    return this.show(message, 'info', title, duration);
  }

  dismiss(id: string) {
    this.toasts.update((current) => current.filter((t) => t.id !== id));
  }
}
